export default "__VITE_ASSET__BU2in3Kx__"